import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { FeatureStore } from '../stores/feature-store';
import { SubscriptionStore } from '../stores/subscription-store';

export const liveLessonAccessGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const nav = router.currentNavigation();

  if (!inject(AuthenticationService).isUserLoggedIn()) {
    return router.parseUrl('/login' + (nav?.finalUrl ? `?redirect=${nav.finalUrl.toString()}` : ''));
  }

  const featureStore = inject(FeatureStore);
  const subscriptionStore = inject(SubscriptionStore);

  if (!featureStore.isFeatureLive('live-lessons-feature')) {
    return router.parseUrl('/dashboard');
  }

  // premium usually has this feature attached to the package
  if (featureStore.hasFeature('live-lessons-feature')) {
    return true;
  }

  // standard condition
  if (subscriptionStore.isSubscribed() && featureStore.isInAccessWindow('live-lessons-feature', 'standard')) return true;

  // free condition
  if (featureStore.isInAccessWindow('live-lessons-feature', 'free')) return true;

  return router.parseUrl('/live-lesson/non-premium');
};
